// extracted by mini-css-extract-plugin
export default {"loaderWrap":"_loader_loaderWrap__xjaWb","loader":"_loader_loader__bS6N3"};